<template>
  <div class="about_us">
    <head-top head-title="关于我们" goBack="true"></head-top>
    <div class="company">
      <span>公司介绍</span>
    </div>
    <div class="company_content">
      <p>
        杭州中正物联信物业服务评估监理有限公司，成立于2018年，公司是一家以互联网及社区治理物业服务评估监理和业主大会第三方服务公司。
        中正物联公司团队库集合了消防、电梯、给排水、绿化、强、弱电等人才。主要服务受聘于政府、业委会等，以公平、公正的第三方服务；
        以物业服务质量评估监理、设施设备查验为主；筹备首届业主大会，业主委员会换届、物业选聘及招投标顾问、政府部门顾问、业主委员会
        顾问服务工作，通过上述服务提高小区生活品质。在第三方的市场中树立起一面旗帜，推动社区治理健康有序的发展。提供（业主大会）会
        务服务作为小区召开业主大会会议新的标准化、规范化流程，为业主大会、业主委员会等工作建立了规范的模式，必将对业主、小区推动社
        区善治与服务创新。创建和谐社区，满意的生活居住环境。对于这一新兴行业，走进社区，服务于广大业主，为政府、业委会排忧解难，市
        场的需求年年递增，我们中正物联始终保持着健康、良好、稳步、持续的发展势头。
      </p>
    </div>
    <div class="idea">
      <div class="our_idea">
        <span>服务理念</span>
      </div>
      <div class="idea_list">
        <div class="row_li">
          <div class="li_box">
            <h2>/<span>01</span>/</h2>
            <p>一起站在互联网的前端，打造健康的物业生态圈</p>
          </div>
          <div class="li_box">
            <h2>/<span>02</span>/</h2>
            <p>以第三方机构的角色提供专业性的物业管理辅导</p>
          </div>
        </div>
        <div class="row_li">
          <div class="li_box">
            <h2>/<span>03</span>/</h2>
            <p>着力提升物业管理服务质量&nbsp;&nbsp;</p>
          </div>
          <div class="li_box">
            <h2>/<span>04</span>/</h2>
            <p>加强物业与业主之间的互动&nbsp;&nbsp;&nbsp;&nbsp;</p>
          </div>
        </div>
        <div class="row_li">
          <div class="li_box">
            <h2>/<span>05</span>/</h2>
            <p>成为一个可以相信又能真正了解物业管理的角色</p>
          </div>
          <div class="li_box">
            <h2>/<span>06</span>/</h2>
            <p>使普通业主更加清楚了解物业管理，更加理性看待与物业之间的关系</p>
          </div>
        </div>
      </div>
    </div>
    <div class="doIt">
      <div class="do_title">
        <span>我们做什么</span>
      </div>
      <div class="do_content">
        <p>以物业服务质量评估监理、设施设备查验为主；筹备首届业主大会，业主委员会换届、物业选聘及招投标顾问、政府部门顾问、业主委员会顾问服务工作。</p>
      </div>
    </div>
    <div class="QR_code">
      <div class="code_title">
        <span>公司二维码</span>
      </div>
      <div class="code_img">
        <img src="./images/erweima1@2x.png" alt="">
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  @import "../../common/sass/index.scss";

  .about_us {
    width: 100%;
    padding-top: 40px;
    background: #fff;
    .company {
      width: 100%;
      height: 43px;
      background: url("./images/xiantiao@2x.png") no-repeat;
      background-position: left;
      span {
        font-size: 15px;
        line-height: 43px;
        margin-left: 15px;
      }
    }
    .company_content {
      width: 96%;
      margin-left: 2%;
      p {
        font-size: 13px;
        line-height: 25px;
      }
    }
    .idea {
      .our_idea {
        width: 100%;
        height: 43px;
        background: url("./images/xiantiao@2x.png") no-repeat;
        background-position: left;
        span {
          font-size: 15px;
          line-height: 43px;
          margin-left: 15px;
        }
      }
      .idea_list {
        padding: 0 10px 10px 10px;
        .row_li {
          display: inline-flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 10px;
          .li_box {
            text-align: center;
            background: #f5f5f5;
            padding: 10px;
            width: 43%;
            height: 80px;
            border-radius: 5px;
            display: inline-block;
            h2 {
              font-size: 15px;
              color: #0078de;
              font-weight: normal;
              span {
                padding: 0 10px;
              }
            }
            p {
              font-size: 13px;
              color: #292929;
              line-height: 20px;
              margin-top: 10px;
            }
          }
        }
      }
    }
    .doIt{
      .do_title {
        width: 100%;
        height: 43px;
        background: url("./images/xiantiao@2x.png") no-repeat;
        background-position: left;
        span {
          font-size: 15px;
          line-height: 43px;
          margin-left: 15px;
        }
      }
      .do_content{
        padding: 10px;
        p{
          background: #f5f5f5;
          padding: 10px;
          font-size: 13px;
          line-height: 20px;
          color: #292929;
          border-radius: 5px;
        }
      }

    }
    .QR_code {
      width: 100%;
      .code_title {
        width: 100%;
        height: 40px;
        background: url("./images/xiantiao@2x.png") no-repeat;
        background-position: left;
        span {
          font-size: 15px;
          line-height: 40px;
          margin-left: 15px;
        }
      }
      .code_img {
        width: 100%;
        height: 78px;
        padding-bottom: 20px;
        img {
          width: 20%;
          height: 100%;
          margin-left: 10px;
          margin-top: 10px;
        }
      }
    }
  }

</style>
<script>
  import headTop from '../header/Header.vue'

  export default {
    name: 'AboutUs',
    data () {
      return {}
    },
    components: {
      headTop
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/my/AboutUs.vue